module.exports = __webpack_public_path__ + "gelddetector_ill.jpg?ec183fbcce2001ca4e408f7a8fcd8462";


//////////////////
// WEBPACK FOOTER
// ./src/assets/placeholders/gelddetector_ill.jpg
// module id = 606
// module chunks = 0